import { Card } from "./Card";
import { Badge } from "./shared/Badge";
import { LineChart } from "./shared/LineChart";
import { useState, useEffect } from "react";
import { RiskLevel, RiskScale } from "../models/RiskScale";
import { MonthDate } from "../helpers/date";
import { TimeSeries, ChartData, computeChartState } from "@/helpers/chartData";

export interface ApiSecurityData {
  description: string;
  timeSeries: TimeSeries[];
}

interface SecurityAdvisoryProps {
  country: string;
  data: ApiSecurityData;
  isLoading: boolean;
}

export function SecurityAdvisoryCard({
  country,
  data,
  isLoading,
}: SecurityAdvisoryProps) {
  const [chartData, setChartData] = useState<ChartData[]>([]);
  const [riskLevel, setRiskLevel] = useState<RiskLevel>(RiskLevel.UNKNOWN);
  const [description, setDescription] = useState<string>(
    "No description available."
  );

  useEffect(() => {
    setDescription(data.description || "No description available.");
    // Transform API data to component format
    const { chartData: transformedData, currentScore } = computeChartState(
      data.timeSeries
    );
    setChartData(transformedData);

    const derivedRisk = RiskScale.getRiskLevelFromScore(currentScore);
    setRiskLevel(derivedRisk);
  }, [data]);

  return (
    <Card>
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-xl font-semibold">Security Advisory</h2>
        <span className="text-sm text-gray-400">{country}</span>
      </div>

      <div className="mb-4">
        <Badge level={riskLevel} />
      </div>

      <p className="text-gray-300 mb-6 text-sm">{description}</p>

      <div className="mt-auto">
        <div className="w-full h-36 sm:h-48 md:h-56 lg:h-72">
          {isLoading ? (
            <div className="flex justify-center items-center h-full">
              <div className="text-gray-400">Loading chart data...</div>
            </div>
          ) : chartData.length > 0 ? (
            <LineChart data={chartData} color="#ff9966" />
          ) : (
            <div className="flex justify-center items-center h-full">
              <div className="text-gray-400">No chart data available</div>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
